import { render, staticRenderFns } from "./ColorPickerCSS.vue?vue&type=template&id=bdd4f1b6&"
import script from "./ColorPickerCSS.vue?vue&type=script&lang=js&"
export * from "./ColorPickerCSS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports